<ng-select
  [clearable]="true"
  [clearOnBackspace]="false"
  #select
  [items]="scenarioConfigList"
  [searchable]="false"
  bindLabel="description"
  placeholder="Unit"
>
  <ng-template ng-header-tmp>
    <div class="has-feedback">
      <input
        type="text"
        class="form-control accordion-search search-input"
        id="inputValidation"
        (input)="select.filter($any($event.target).value)"
        placeholder="Search..."
      />
      <span class="form-control-feedback">
        <i class="fa fa-search icon"></i>
      </span>
    </div>
  </ng-template>
  <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
    <div [ngOptionHighlight]="search" title="{{ item?.description }}">{{ item?.description }}</div>
    <div [ngOptionHighlight]="search" title="{{ item?.name }}">{{ item.name }}</div>
  </ng-template>
</ng-select>
